import BookmarkButton from './BookmarkButton';

export default BookmarkButton;
